import { useState } from 'react'
import type React from 'react'

interface Props {
  text: string
  children: React.ReactNode
  width?: number
}

const wrapStyle: React.CSSProperties = {
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
}

const bubbleBaseStyle: React.CSSProperties = {
  position: 'absolute',
  bottom: '100%',
  left: '50%',
  transform: 'translateX(-50%)',
  marginBottom: 8,
  padding: '8px 10px',
  borderRadius: 8,
  fontSize: 12,
  lineHeight: 1.4,
  color: '#fff',
  background: '#2C3E50',
  zIndex: 50,
  boxShadow: '0 6px 16px rgba(15, 23, 42, 0.18)',
  pointerEvents: 'none',
}

const arrowStyle: React.CSSProperties = {
  position: 'absolute',
  top: '100%',
  left: '50%',
  transform: 'translateX(-50%)',
  width: 0,
  height: 0,
  borderLeft: '6px solid transparent',
  borderRight: '6px solid transparent',
  borderTop: '6px solid #2C3E50',
}

export const Tooltip: React.FC<Props> = ({ text, children, width = 220 }) => {
  const [show, setShow] = useState(false)

  return (
    <span
      style={wrapStyle}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      onFocus={() => setShow(true)}
      onBlur={() => setShow(false)}
    >
      {children}
      {show && (
        <span style={{ ...bubbleBaseStyle, width }}>
          {text}
          <span style={arrowStyle} />
        </span>
      )}
    </span>
  )
}
